module.exports = __webpack_public_path__ + "static/media/machine-learning.6ad26e20.png";